import type { ReactNode } from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import ScrollToTop from "./ScrollToTop";
import BackToTop from "@/components/base/BackToTop";

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <ScrollToTop />
      <SiteHeader />
      <main className="flex-1 w-full">{children}</main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}